import BaseApi from './BaseApi'

class AreasOfSpecialisationApi extends BaseApi {
  get specialisationsUrl () {
    return 'financialServices'
  }

  fetchingAreasOfSpecialisation () {
    return this.getJson(this.specialisationsUrl)
  }
}
export default AreasOfSpecialisationApi

